export function ProgressBar({ pct, className = "", glow = false }) {
  return (
    <div className={`h-2 w-full bg-zinc-900 overflow-hidden ${className}`}>
      <div
        data-testid="progress-bar-fill"
        className="h-full bg-[#fa003f] transition-[width] duration-500 ease-out"
        style={{
          width: `${pct}%`,
          boxShadow: glow && pct > 0 ? "0 0 10px rgba(250,0,63,0.6)" : "none",
        }}
      />
    </div>
  );
}
